// DOM Ready functions using custom async function so it only funs when jQuery has been fully loaded
async.push(["ready", function() {
    // Advanced search form filters
    refineSearchFilters();
}]);

// Toggle Advanced Search fields
function toggleAdvancedSearch(button) {
    // Basic Search mode
    if ($('input[name=advancedsearch]').val() == 1) {
        $('input[name=advancedsearch]').val(0);

        // hide
        $('#advanced-seach-fields').addClass('hide');
        $('#advanced-seach-fields').removeClass('show');
        button.text('More Options');

        // reset form
        $('#reset-search').trigger('click');

        $('#advanced-search .modal-title').text('Vehicle Search');
    } else {
        $('input[name=advancedsearch]').val(1);

        // show advanced
        $('#advanced-seach-fields').addClass('show');
        $('#advanced-seach-fields').removeClass('hide');
        button.text('Less Options');

        $('#advanced-search .modal-title').text('Advanced Search');
    }
}

// Advanced search filters
window.refineSearchFilters = function refineSearchFilters() {
    // remove tags from search filters
    // $('.searchfiltertag').on('click', function() {
    //     var param = $(this).data('key');
    //     var subParam = $(this).data('subkey') ? $(this).data('subkey') : false;

    //     var friendlyParams = ['branchid','type','manufacturer','model'];
    //     if($.inArray(param, friendlyParams ) > -1){

    //         $('#filter-'+param).val('');

    //         // don't log search
    //         $('input[name=logsearch]').val(0);

    //         // submit search form
    //         $('#form-advancedsearch').submit();
    //         return;
    //     }
    //     url = removeURLParameter(document.location.href, param, subParam);
    //     document.location.href = url;
    // });
    // Used Vehicles list filters
    // $('#filter-sortby').on('change', function(e) {
    //     var form = $(this).closest('form');
    //     form.submit();
    // });

    // filter by branch
    // $('.filter-branch').on('click', function(){

    //     $('.btn-group-branch .btn').removeClass('active');
    //     $(this).addClass('active');

    //     // set branchid
    //     $('#filter-branchid').val($(this).data('branchid'));

    //     // submit search form
    //     $('#form-advancedsearch').submit();
    // });

    // if($('#search-filters').length){

    // $('.filter-select').on('change', function(e) {
    //     e.stopImmediatePropagation();
    //     console.log($(this).attr('id'));
    //     updateSearchFilters($(this).attr('id'));
    // });
    // }

    // reset search filters
    $('.reset-filters').on('click', function(e) {

        // reset selects
        $('#form-advancedsearch').find('select').val('');
        $('#filter-manufacturer').trigger('change');

        $('#form-advancedsearch').find('.search-field').val('');

        $('input[name=sale], input[name=newarrivals]').val('')
        resetSearchSliders();

    });

    // Toggle advanced search fields
    $('#toggle-advancedsearch').on('click', function(e) {
        e.preventDefault();
        toggleAdvancedSearch($(this));
    });

    // BEGIN: Payment Range Slider
    PaymentSlider = $("#payment-range-slider").slider({
        orientation: 'horizontal',
        range: true,
        min: PaymentSliderMin_default,
        max: PaymentSliderMax_default,
        step: 5,
        values: [PaymentSliderMin, PaymentSliderMax],
        // additional options for slider bound limits
        // minRangeSize : 1,
        // lowMax: 45000,
        // topMin: 2000,
        animate: true,
        slide: function(event, ui) {

            // update slider values and display text
            updateSlider('payment', ui, PaymentSliderMin_default, PaymentSliderMax_default);
        },
        change: function(event, ui) {

            // update slider values and display text
            updateSlider('payment', ui, PaymentSliderMin_default, PaymentSliderMax_default);
        },
        create: function(event, ui) {
            $(this).draggable(); // Enable draggable after slider is created
        }
    });

    // END: Price Range Slider

    // BEGIN: Price Range Slider
    PriceSlider = $("#price-range-slider").slider({
        orientation: 'horizontal',
        range: true,
        min: PriceSliderMin_default,
        max: PriceSliderMax_default,
        step: PriceSliderMin_default,
        values: [PriceSliderMin, PriceSliderMax],
        // additional options for slider bound limits
        // minRangeSize : 1,
        // lowMax: 45000,
        // topMin: 2000,
        animate: true,
        slide: function(event, ui) {
            // update slider values and display text
            updateSlider('price', ui, PriceSliderMin_default, PriceSliderMax_default);
        },
        change: function(event, ui) {
            // update slider values and display text
            updateSlider('price', ui, PriceSliderMin_default, PriceSliderMax_default);
        },
        create: function(event, ui) {

            const priceMinFormatted = number_format(PriceSliderMin, 0);
            const priceMaxFormatted = number_format(PriceSliderMax, 0);

            $(this).draggable(); // Enable draggable after slider is created
            updateSlider('price', { values: [priceMinFormatted, priceMaxFormatted] }, PriceSliderMin_default, PriceSliderMax_default);
        }
    });
    // END: Price Range Slider

    // BEGIN: KM Range Slider
    KmSlider = $("#km-range-slider").slider({
        orientation: 'horizontal',
        range: true,
        min: KmSliderMin_default,
        max: KmSliderMax_default,
        step: 10000,
        values: [KmSliderMin, KmSliderMax],
        animate: true,
        slide: function(event, ui) {
            // update slider values and display text
            updateSlider('km', ui, KmSliderMin_default, KmSliderMax_default);
        },
        change: function(event, ui) {
            // update slider values and display text
            updateSlider('km', ui, KmSliderMin_default, KmSliderMax_default);
        },
        create: function(event, ui) {

            const kmMinFormatted = number_format(KmSliderMin, 0);
            const kmMaxFormatted = number_format(KmSliderMax, 0);

            $(this).draggable(); // Enable draggable after slider is created
            updateSlider('km', { values: [kmMinFormatted, kmMaxFormatted] }, KmSliderMin_default, KmSliderMax_default);
        }
    });
    // END: Km Range Slider

    // BEGIN: TradeIn Vehicle Price Range Slider
    TradeInPriceSlider = $("#tradein-price-range-slider").slider({
        orientation: 'horizontal',
        range: true,
        min: TradeInPriceSliderMin_default,
        max: TradeInPriceSliderMax_default,
        step: 5000,
        values: [TradeInPriceSliderMin, TradeInPriceSliderMax],
        // additional options for slider bound limits
        // minRangeSize : 1,
        // lowMax: 45000,
        // topMin: 2000,
        animate: true,
        slide: function(event, ui) {
            // update slider values and display text
            updateSlider('tradeinprice', ui, TradeInPriceSliderMin_default, TradeInPriceSliderMax_default);
        },
        change: function(event, ui) {
            // update slider values and display text
            updateSlider('tradeinprice', ui, TradeInPriceSliderMin_default, TradeInPriceSliderMax_default);
        },
        create: function(event, ui) {
            $(this).draggable(); // Enable draggable after slider is created
        }
    });
    // END: TradeIn Vehicle Price Range Slider

    // BEGIN: TradeIn Vehicle Price Range Slider
    PurchaseVehiclePriceSlider = $("#purchasevehicle-price-range-slider").slider({
        orientation: 'horizontal',
        range: true,
        min: TradeInPriceSliderMin_default,
        max: TradeInPriceSliderMax_default,
        step: 5000,
        values: [PurchaseVehiclePriceSliderMin, PurchaseVehiclePriceSliderMax],
        // additional options for slider bound limits
        // minRangeSize : 1,
        // lowMax: 45000,
        // topMin: 2000,
        animate: true,
        slide: function(event, ui) {
            // update slider values and display text
            updateSlider('purchasevehicleprice', ui, TradeInPriceSliderMin_default, TradeInPriceSliderMax_default);
        },
        change: function(event, ui) {
            // update slider values and display text
            updateSlider('purchasevehicleprice', ui, TradeInPriceSliderMin_default, TradeInPriceSliderMax_default);
        }, 
        create: function(event, ui) {
            $(this).draggable(); // Enable draggable after slider is created
        }
    });
    // END: TradeIn Vehicle Price Range Slider

    // Seats
    var seatsField = $('input[name=seats]');
    $('.btn-seats').on('click', function() {
        $('.btn-seats').not(this).removeClass('active');
        var seats = $(this).text();

        // toggle active class and set/unset value
        if ($(this).hasClass('active')) {
            seatsField.val('');
            $(this).removeClass('active');
        } else {
            seatsField.val(seats);
            $(this).addClass('active');
        }
    });

    // Car price / KM button toggler
    var filterrangeField = $('input[name=filterrange]');
    var rangetypeField = $('input[name=rangetype]');

    $('.btn-filterrange').on('click', function() {

        $('.btn-filterrange').not(this).removeClass('active');
        $('.btn-rangetype').removeClass('active');

        var filterrange = $(this).data('filterrange');

        // toggle active class and set/unset value
        if ($(this).hasClass('active')) {
            filterrangeField.val('');
            $(this).removeClass('active');

            // hide both
            $('#filterrange-price').addClass('hide');
            $('#price-range-both-wrap').addClass('hide');
            $('#km-range-slider-wrap').addClass('hide');
        } else {
            filterrangeField.val(filterrange);
            $(this).addClass('active');

            // show/hide range sliders
            if (filterrange === 'price') {
                $('#filterrange-price').removeClass('hide');
                $('#km-range-slider-wrap').addClass('hide');
                $('#price-range-both-wrap').removeClass('hide');
            } else if (filterrange === 'km') {
                $('#filterrange-price').addClass('hide');
                $('#km-range-slider-wrap').removeClass('hide');
                $('#price-range-both-wrap').addClass('hide');
            }
        }
    });

    // Car price / Weekly payment button toggler
    $('.btn-rangetype').on('change', function() {
        $('.btn-rangetype').not(this).removeClass('active');
        var rangetype = $(this).val();

        // show/hide range sliders
        if (rangetype === 'price') {
            $('#price-range-slider-wrap').removeClass('hide');
            $('#payment-range-slider-wrap').addClass('hide');
        } else if (rangetype === 'weeklypayment') {
            $('#price-range-slider-wrap').addClass('hide');
            $('#payment-range-slider-wrap').removeClass('hide');
        }
    });
} // end refineSearchFilters()

// get ajax search filters
function updateSearchFilters(select) {

    // get saction from data attribute
    var saction = $('#' + select).data('saction');
    console.log(saction, $('#filter-manufacturer').val());
    if (saction === undefined) {
        return;
    }

    $.ajax({
        url: '/api/vehicles/data/' + saction,
        data: {
            'filtertype': select,
            'manufacturer': $('#filter-manufacturer').val(),
            'model': $('#filter-model').val(),
            'year': $('#filter-year').val(),
            'type': $('#filter-type').val(),
            'externalcolour': $('#filter-externalcolour').val(),
            'fueltype': $('#filter-fueltype').val(),
            'fuelstars': $('#filter-fuelstars').val(),
            'transmission': $('#filter-transmission').val(),
        },
        method: 'post'
    }).done(function(response) {
        // update search filters
        updateSelectOptions($('#' + select), response);
        // $('#form-advancedsearch').find('.selectpicker').selectpicker('refresh');

    });
}

// Update Select picker options
function updateSelectOptions(select, response) {

    var target = select.data('target');
    $(target).html(response);

    // trigger change to update target select and trigger chain of events
    $(target).trigger('change');

    // $('#form-advancedsearch').find('.selectpicker').selectpicker('refresh');
}

function resetSearchSliders() {
    PaymentSlider.slider("values", 0, PaymentSliderMin_default);
    PaymentSlider.slider("values", 1, PaymentSliderMax_default);
    PriceSlider.slider("values", 0, PriceSliderMin_default);
    PriceSlider.slider("values", 1, PriceSliderMax_default);
}

// update price UI sliders
function updateSlider(slider, ui) {
    $('#' + slider + 'min').val(ui.values[0]);
    $('#' + slider + 'max').val(ui.values[1]);

    // Formatted Label - using native JS number formatting
    $('#' + slider + 'min-display').text(ui.values[0].toLocaleString());
    
    // Max price 50k+
    if (slider == "price") {
        if (ui.values[1] >= 50000) {
            $('#' + slider + 'max-display').text("50k+");
        } else {
            $('#' + slider + 'max-display').text(ui.values[1].toLocaleString());
        }
    }

    // Payment Max
    if (slider == "payment") {
        if (ui.values[1] >= 200) {
            $('#' + slider + 'max-display').text("200+");
        } else {
            $('#' + slider + 'max-display').text(ui.values[1].toLocaleString());
        }
    }

    // KMs+
    if (slider == "km") {
        if (ui.values[1] >= 250000) {
            $('#' + slider + 'max-display').text("250,000+");
        } else {
            $('#' + slider + 'max-display').text(ui.values[1].toLocaleString());
        }
    }
}
// function updateSlider(slider, ui) {

//     $('#' + slider + 'min').val(ui.values[0]);
//     $('#' + slider + 'max').val(ui.values[1]);

//     // Formatted Label
//     $('#' + slider + 'min-display').number(ui.values[0], 0);
//     // Max price 50k+
//     if (slider == "price") {
//         if (ui.values[1] >= 50000) {
//             $('#' + slider + 'max-display').text("50k+");
//         } else {
//             $('#' + slider + 'max-display').number(ui.values[1], 0);
//         }
//     }

//     // Payment Max
//     if (slider == "payment") {
//         if (slider == "payment" && ui.values[1] >= 200) {
//             $('#' + slider + 'max-display').text("200+");
//         } else {
//             $('#' + slider + 'max-display').number(ui.values[1], 0);
//         }
//     }

//     // KMs+
//     if (slider == "km") {
//         if (ui.values[1] >= window.KmSliderMax) {
//             $('#' + slider + 'max-display').text("250,000+");
//         } else {
//             $('#' + slider + 'max-display').number(ui.values[1], 0);
//         }
//     }
// }

function removeURLParameter(url, parameter, subparameter) {

    //prefer to use l.search if you have a location/link object
    var urlparts = url.split('?');

    if (urlparts.length >= 2) {

        // remove nested arrays too
        if (subparameter) {
            var prefix = encodeURIComponent(parameter) + '[' + encodeURIComponent(subparameter) + ']=';
        } else {
            var prefix = encodeURIComponent(parameter) + '=';
        }

        var pars = urlparts[1].split(/[&;]/g);

        //reverse iteration as may be destructive
        for (var i = pars.length; i-- > 0;) {
            //idiom for string.startsWith
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }

        url = urlparts[0] + '?' + pars.join('&');
        return url;
    } else {
        return url;
    }
}